import DummyPage from './DummyPage';

export default function ReportPage() {
  return <DummyPage title="보고서" description="다양한 보고서를 생성하고 조회할 수 있습니다." />;
}
